(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const menuRoot = document.querySelector(".mobile_main_nav_list");
    const menuBtn = document.querySelector(".menu-btn");
    const menuDrawer = document.querySelector(".mobile_navigation_wrap");
    const html = document.documentElement;
    if (!menuRoot) return;

    function setActive(li) {
      const parentUl = li.closest("ul");
      if (!parentUl) return;

      const siblings = parentUl.querySelectorAll(":scope > li");
      siblings.forEach((sib) => {
        if (sib === li) {
          sib.classList.add("item_active");
          sib.classList.remove("item_disable");
        } else {
          sib.classList.remove("item_active");
          sib.classList.add("item_disable");
        }
      });
    }

    function clearStates() {
      menuRoot
        .querySelectorAll("li")
        .forEach((li) =>
          li.classList.remove("item_active", "item_disable")
        );
    }

    function isCheckboxChecked(li) {
      const checkbox = li.querySelector(":scope > .m-menu__checkbox");
      return checkbox && checkbox.checked;
    }

    // ---------------- HOVER ----------------
    menuRoot.addEventListener("mouseover", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;

      const from = e.relatedTarget;
      if (from && li.contains(from)) return;

      if (isCheckboxChecked(li)) {
        li.classList.remove("item_active", "item_disable");
        return;
      }

      setActive(li);
    });

    // ---------------- REMOVE ACTIVE WHEN MOUSE LEAVES LI ----------------
    menuRoot.addEventListener("mouseout", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;

      const to = e.relatedTarget;
      if (to && li.contains(to)) return;

      li.classList.remove("item_active", "item_disable");

      const parentUl = li.closest("ul");
      if (parentUl) {
        parentUl.querySelectorAll(":scope > li").forEach((sib) =>
          sib.classList.remove("item_active", "item_disable")
        );
      }
    });

    // ---------------- CLICK ----------------
    menuRoot.addEventListener("click", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;
      e.stopPropagation();

      if (isCheckboxChecked(li)) {
        li.classList.remove("item_active", "item_disable");
        return;
      }

      const parentUl = li.closest("ul");
      const siblings = parentUl.querySelectorAll(":scope > li");

      if (li.classList.contains("item_active")) {
        siblings.forEach((sib) =>
          sib.classList.remove("item_active", "item_disable")
        );
      } else {
        setActive(li);
      }
    });

    // ---------------- OUTSIDE CLICK CLEAR STATES ----------------
    document.addEventListener("click", function (e) {
      if (
        html.classList.contains("menu_drawer_open") &&
        menuDrawer &&
        !menuDrawer.contains(e.target) &&
        menuBtn &&
        !menuBtn.contains(e.target)
      ) {
        html.classList.remove("menu_drawer_open");
        clearStates();
      }
    });

    // ---------------- MENU BUTTON ----------------
    // menuBtn?.addEventListener("click", function (e) {
    //   e.stopPropagation();

    //   if (html.classList.contains("menu_drawer_open")) {
    //     html.classList.remove("menu_drawer_open");
    //   } else {
    //     html.classList.add("menu_drawer_open");
    //   }
    // });
  }
})();


// Menu Icon Custom (converted from jQuery)
document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector(".menu-btn");
  const body = document.body;
  const html = document.documentElement;
  const modalSearch = document.querySelector(".modal-search");
  const overlay = document.querySelector(".mobile_menu_overlay");
  const crossBtn = document.querySelector(".mobile-nav-trigger_cross");

  // When menu button is clicked
  if (menuBtn) {
    menuBtn.addEventListener("click", function () {

      const isOpen = html.classList.contains("menu_drawer_open");

      if (isOpen) {
        // Close
        html.classList.remove("menu_drawer_open");
        body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
        menuBtn.classList.remove("open", "isactive");
      } else {
        // Open
        html.classList.add("menu_drawer_open");
        body.classList.add("mobile_nav_opened");
        menuBtn.classList.add("open", "isactive");

        if (window.scrollY === 0) {
          body.classList.add("mobile_nav_bar_top_no_scroll");
        }
      }

      if (modalSearch) {
        modalSearch.classList.remove("expand-searchnew", "show");
        modalSearch.style.display = "none";
      }
    });
  }

  // When clicking on overlay — close menu
  if (overlay) {
    overlay.addEventListener("click", function () {
      body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
      html.classList.remove("overflow_hidden");
      html.classList.remove("menu_drawer_open");

      body.style.overflow = "";
      body.style.height = "";

      menuBtn?.classList.remove("open", "isactive");
    });
  }

  // When cross button is clicked (optional separate close icon)
  if (crossBtn) {
    crossBtn.addEventListener("click", function () {
      body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
      html.classList.remove("overflow_hidden");
      html.classList.remove("menu_drawer_open");

      body.style.overflow = "";
      body.style.height = "";

      menuBtn?.classList.remove("open", "isactive");
    });
  }
});


// announcement Bar
document.addEventListener("DOMContentLoaded", () => {
  const announcementBarContainer = document.querySelector(".mds-animated-banner__slider-container");
  const announcementSlides = announcementBarContainer.querySelectorAll(".mds-animated-banner__content");
  let activeSlideIndex = 0;

  function updateSlideClasses() {
    announcementSlides.forEach((slide) => slide.classList.remove("-visible", "-next"));
    announcementSlides[activeSlideIndex].classList.add("-visible");
    const nextSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;
    announcementSlides[nextSlideIndex].classList.add("-next");
  }

  function showNextAnnouncementSlide() {
    activeSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;
    updateSlideClasses();
  }

  updateSlideClasses();
  setInterval(showNextAnnouncementSlide, 4000);
});


// Scroll handling: direction + sticky header
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  let lastScroll = 0;
  const scrollThreshold = 100;

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset;

    // header_sticky toggle
    if (currentScroll > 0) {
      body.classList.add("header_sticky");
    } else {
      body.classList.remove("header_sticky");
    }

    // scroll direction toggle
    if (currentScroll > scrollThreshold) {
      if (currentScroll > lastScroll) {
        body.classList.add("body_scroll_down");
        body.classList.remove("body_scroll_up");
      } else {
        body.classList.add("body_scroll_up");
        body.classList.remove("body_scroll_down");
      }
    } else {
      body.classList.remove("body_scroll_down", "body_scroll_up");
    }

    lastScroll = currentScroll;
  });
});

document.addEventListener('DOMContentLoaded', function () {

    const wrapper = document.querySelector('.mobile-nav-menu-wrapper');
    let lastScroll = 0;

    if (!wrapper) return;

    /* ---------------------------------
       SUBMENU OPEN (Freeze → Reset → Unfreeze)
    ----------------------------------*/
    document.querySelectorAll('.m-menu__checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {

            wrapper.style.scrollBehavior = 'auto';

            if (this.checked) {
                // Save current scroll
                lastScroll = wrapper.scrollTop;

                // Freeze scrolling
                wrapper.style.overflow = 'hidden';

                // Jump to top instantly
                wrapper.scrollTop = 0;

                // Unfreeze next frame
                requestAnimationFrame(function () {
                    wrapper.style.overflow = '';
                });
            }
        });
    });

    /* ---------------------------------
       SUBMENU CLOSE (Freeze → Restore → Unfreeze)
    ----------------------------------*/
    document.querySelectorAll('.m-menu__toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {

            // Freeze before restoring scroll
            wrapper.style.overflow = 'hidden';

            // Restore previous scroll position
            wrapper.scrollTop = lastScroll;

            // Unfreeze next frame
            requestAnimationFrame(function () {
                wrapper.style.overflow = '';
            });
        });
    });
});


window.addEventListener('scroll', function () {
  const headerNav = document.querySelector('.header_Nav');

  if (!headerNav) return;

  if (window.scrollY > 0) {
    headerNav.classList.add('fixed-nav-container');
  } else {
    headerNav.classList.remove('fixed-nav-container');
  }
});




window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('preload');
  });
});